import React, { PropTypes } from 'react';
import { CargoType } from 'types';
import Subcategory from 'components/Subcategory';
import { CategoryType } from 'types';
import Immutable from 'immutable';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import './Subcategories.scss';

class Subcategories extends React.Component {

    static propTypes = {
        cargos: PropTypes.arrayOf(CargoType).isRequired,
        onCargoFinish: PropTypes.func,
        deliveryCargos: PropTypes.instanceOf(Immutable.List),
        selectedCategory: PropTypes.instanceOf(CategoryType),
    };

    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    render() {
        var allSubcategories = this.props.cargos.map((cargo, index) => {

            var selected = false;

            if (this.props.selectedCategory.name === 'book_separate_car') {
                var selectedSubcategory = this.props.deliveryCargos.find((deliveryCargo) => {
                    return deliveryCargo.get('stuff_type_id') === cargo.get('stuff_type_id')
                });

                if (selectedSubcategory) {
                    selected = true;
                }
            }

            return (
                <div className="Subcategories-item"
                    key={index}>
                    <Subcategory
                        selected={selected}
                        cargo={cargo}
                        selectedCategory={this.props.selectedCategory}
                        onCargoFinish={this.props.onCargoFinish} />
                </div>
            );
        });

        var subcategoriesTitle = 'Выберите подкатегорию';
        if (this.props.selectedCategory.name === 'book_separate_car') {
            subcategoriesTitle = 'Выберите тип грузовика';
        }

        return (
            <div className="Subcategories">
                <header className="Subcategories-header">
                    <div className="Subcategories-title">
                        {subcategoriesTitle}
                    </div>
                </header>
                <div className="Subcategories-list">
                    {allSubcategories}
                </div>
            </div>
        );
    }

}

export default Subcategories;



// WEBPACK FOOTER //
// ./client/components/Subcategories/Subcategories.js